import m from 'mithril'
import accessDialog from './oauth/access-dialog'
import { home, question, appIcons } from '../lib/icons'


var allowFuture = {}
var errorMsg = null

export default {
  view(vnode) {
    var {user, client, scopeDetails, transaction_id} = vnode.attrs

    return accessDialog({
      title: "Installation Request",
      client: client,
      transaction_id: transaction_id
    },
      m('.text-large.py-2',
        client.meta.name ? m('b', client.meta.name) : m('b', 'An ', m('i', 'anonymous app'))
      ),
      m('p',
        "...is requesting privilege to store data in your BYOD Home.",
        m('br'),
      ),

      scopeDetails.length
      ? [
        m('p', "It wants to:"),

        m('.text-left.text-margin.pb-2.d-inline-flex.flex-col.flex-justify-center',
          scopeDetails.map( details =>
            m(ScopeDetails, {
              client: client,
              details: details,
            })
          )
        ),

        m('button[type=submit].btn.btn-success.btn-block.mb-2', "Authorize " + client.host),


        m('small.p-2', "Authorizing will redirect back to their website."),
      ] : [
        m('p', m('b', 'However, '), `it did not ask for any specific permissions,
                and therefore cannot be granted any permissions.`),
        m('p', `This their fault, not yours. If you want to use this Bapp,
                I suggest you contact them about this bug.`),

        m('button.btn.m-1', {
          onclick: () => window.location.replace(client.redirect_uri)
        }, "< Back to their website"),
        m('button.btn.m-1', {
          onclick: () => window.location.replace('/admin')
        }, "Manage My Stuff >"),
      ],
    )
  }
}

const ScopeDetails = {
  oninit(vnode) {
    vnode.state.open = false
    vnode.state.allowAnyway = false
  },
  toggle() {
    if ( this.allowAnyway ) {
      // Do nothing; checkbox needs to stay in DOM
    }
    else {
      this.open = ! this.open
    }
  },
  view({ state, attrs }) {
    var {client, details} = attrs

    var label, icon

    //
    // TODO: Handle read-only and write-only scopes
    //
    if ( ! details.isForeign ) {
      icon = "👍"
      label = "Read & Write its own data"
    }
    else {
      icon = details.valid
        ? m('.tooltip[data-tooltip="Please consider the security of this request!"]',
            "🤔",
            m('.icon', appIcons[details.metacategoryIcon]
              ? m('.icon', appIcons[details.metacategoryIcon])
              : null
            ),
          )
        : details.installed
          ? m('.tooltip.text-error[data-tooltip="This request is invalid."]', "⁉")
          : m('.tooltip[data-tooltip="This app is not installed."]', "🚫")
      label = ["Read & Write", m('br'), m('b',details.meta.name), " app data"]
    }

    var showDescription = state.open && details.valid

    return m('.tile.bg-gray.mb-1.p-2',
      { style: `border: 1px solid #ccc; flex: 1 0 auto` },
      m('.tile-icon', icon),
      m('.tile-content.flex',
        m('.tile-title', label),
        m('.tile-subtitle.text-gray', details.host),

        ! details.isForeign &&
        m('.pt-2', details.meta.description),

        details.isForeign && (
          details.installed
            ? m('.text-success',
                "You are granting access to this already-installed app. Be careful!"
              )
            : m('.text-error', "Not Installed")
        ),

        // Use .hhide to avoid janky width changes
        m('.pt-2', { class: state.open ? '' : 'hhide' },

          details.valid ? [
            m('div', details.meta.description),
          ] : [
            m('.toast',
              "Because this app is not installed, ",
              m('b', client.meta.name),
              " will not be granted access to this app."
            ),

            m('.form-group',
              m('label.form-checkbox',
                m('input[type=checkbox]', {
                  name: `allow_future[${encodeURIComponent(details.scope)}]`,
                  value: state.allowAnyway,
                  onchange: e => state.allowAnyway = e.target.checked,
                }),
                m('i.form-icon'),
                m('span', `Grant access to future installs of ${details.meta.name} (this doesn't do anything yet)`)
              )
            ),
          ],
        )
      ),

      details.isForeign &&
        m('.tile-action',
          m('button[type=button].btn.btn-sm', {
            disabled: state.allowAnyway,
            style: `width: 3.75rem;`,
            onclick: () => state.toggle()
          }, state.open ? "Close" : "Details")
        )
    )
  }
}
